import API from '../../../../services/TAPS_API';

export default function sendNotificationData(data, id, actionType) {
  return API.request({
    method: 'POST',
    url: actionType ? `/notification/${id}/${actionType}` : `/notification/${id}`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getNotificationData(data, id) {
  return API.request({
    method: 'GET',
    url: `/notification/${id}/info?cardId=${data.cardId}`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function signReportFormMessage(data, id) {
  return API.request({
    method: 'POST',
    url: `/notification/${id}/signAcceptTicket`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
  });
}

export function sendNotificationDataCardId(data, id, actionType, cardId) {
  return API.request({
    method: 'POST',
    url: `/notification/${id}/${actionType}/${cardId}`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
export function validateNotificationData(data, id, step) {
  return API.request({
    method: 'POST',
    url: `/notification/${id}/validate?step=${step}`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getLastNotificationCardId(id) {
  return API.request({
    method: 'GET',
    url: `/notification/${id}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getFundsMovingDraft(id, accountOperation, correction = false) {
  return API.request({
    method: 'GET',
    url: `/notification/${id}/loadDraft${
      accountOperation ? `?accountOperation=${accountOperation}&` : ''
    }?correction=${correction}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function saveFundsMovingDraft(data, id) {
  return API.request({
    method: 'POST',
    url: `/notification/${id}/saveDraft`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

export function getNotificationResponseByCardId(id, cardId) {
  return API.request({
    method: 'GET',
    url: `/notification/${id}/pdf`,
    params: {
      cardId,
    },
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    responseType: 'arraybuffer',
  });
}
